// extracted by mini-css-extract-plugin
export default {"dropdownWrapper":"adminDropdown_dropdownWrapper__EypFm","moreIcon":"adminDropdown_moreIcon__Ej-bW","dropdown":"adminDropdown_dropdown__GTedU"};